/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{isMultiOriginJSONMixin as r}from"../multiOriginJSONSupportUtils.js";function i(i){i?.writtenProperties&&i.writtenProperties.forEach(({target:i,propName:t,newOrigin:e})=>{r(i)&&e&&i.originOf(t)!==e&&i.updateOrigin(t,e)})}export{i as updateOrigins};
